/* Ueberblendung der Hero-Bilder und der zugehoerigen Textbloecke.

   Bewusst ohne Bibliothek: Es wird nur eine Klasse getauscht, die Animation
   macht CSS. Laeuft nur, wenn es mehr als ein Bild gibt.

   Seit 07.09.2026 gibt es zu jedem Slide einen eigenen Textblock
   ([data-lr-pane]), damit ein Aktions-Slide eigene Schlagzeile, Buttons und
   einen Countdown mitbringen kann. Bild und Text werden zusammen geschaltet.
   Sicherheitsnetz: Nur wenn es genauso viele Textbloecke wie Bilder gibt,
   wird umgeschaltet – sonst bliebe bei einem Fehler gar kein Text stehen.

   Der Wechsel pausiert, wenn der Tab im Hintergrund liegt oder die Maus auf
   dem Hero steht, und startet gar nicht erst bei prefers-reduced-motion –
   dann bleiben das erste Bild und der erste Text stehen. */
(function () {
  function init(root) {
    if (root.dataset.lrHeroReady) return;
    root.dataset.lrHeroReady = '1';

    var slides = root.querySelectorAll('[data-lr-slide]');
    var panes = root.querySelectorAll('[data-lr-pane]');
    var dots = root.querySelectorAll('[data-lr-dot]');
    if (slides.length < 2) return;

    var syncPanes = panes.length === slides.length;
    var i = 0;
    var timer = null;
    var wait = parseInt(root.dataset.lrHeroInterval, 10) || 7000;
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function show(n) {
      i = (n + slides.length) % slides.length;
      for (var k = 0; k < slides.length; k++) {
        slides[k].classList.toggle('is-on', k === i);
        var img = slides[k].querySelector('img');
        if (k === i && img && img.loading === 'lazy') img.loading = 'eager';
        if (syncPanes) panes[k].classList.toggle('is-on', k === i);
      }
      for (var d = 0; d < dots.length; d++) {
        dots[d].setAttribute('aria-current', d === i ? 'true' : 'false');
      }
    }

    function start() {
      if (still || timer) return;
      timer = setInterval(function () { show(i + 1); }, wait);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    for (var d = 0; d < dots.length; d++) {
      (function (n) {
        dots[n].addEventListener('click', function () { stop(); show(n); start(); });
      })(d);
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    show(0);
    start();
  }

  function boot() {
    var all = document.querySelectorAll('[data-lr-hero]');
    for (var i = 0; i < all.length; i++) init(all[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
